import { gql } from '@apollo/client'

const lotEvents = gql`
  query lotEvents($id: Int!) {
    lotEvents(lotId: $id) {
      id
      name
      latitude
      longitude
      venueName
      rawAddress
      start
      timezoneName
      defaultAvailability {
        id
        startTime
        endTime
      }
      mainPhoto {
        info {
          mode
          cloudinary {
            cloudName
            publicId
            format
            defaultTransformation
          }
          url
        }
        rawInfo
        fallbackUrl
      }
      waitlistEnabled
      waitlistOpen
      inWaitlist
      postponed
      soldOut
    }
  }
`

export default lotEvents
